import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import ProductDetails from "../components/sellScreen/productDetails";
import ViewCustomerDetails from "../components/sellScreen/viewCustomerDetails";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";
import NewSellscreen from "../components/newSellscreen/newSellscreen";
import { OrderSummary } from "../components/newSellscreen/orderSummary";
import AddEditCustomerScreen from "../components/customers/addEditCustomerScreen";
import OrderTab from "./orderScreen";
import OrderDetails from "../components/orders/orderDetails";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */

const SellScreenStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();
    return (
        <AppStack.Navigator
            initialRouteName={"NewSellScreen"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="NewSellScreen" component={NewSellscreen} />
            <AppStack.Screen name="OrderSummary" component={OrderSummary} />
            <AppStack.Screen name="ViewCustomerDetails" component={ViewCustomerDetails} />
            <AppStack.Screen name="AddEditCustomer" component={AddEditCustomerScreen} />
            <AppStack.Screen component={OrderTab} name="OrderList" />
            <AppStack.Screen name="ProductDetails" component={ProductDetails} />
            <AppStack.Screen component={OrderDetails} name="OrderDetails" />
        </AppStack.Navigator>
    );
};

export default SellScreenStack;